interface Attacment {
  acceptedInput: string;
  acceptedInputExtended?: string;
  extension: RegExp;
  type: RegExp;
}

type SupportAttachments = Record<string, Attacment>;

const isImage = (
  fileName: string,
  contentType: string
): RegExpExecArray | null => {
  const { image } = getSupportedAttachments();

  return image.extension.exec(fileName) && image.type.exec(contentType);
};

const getSupportedAttachments = (): SupportAttachments => ({
  image: {
    acceptedInput: "image/*",
    acceptedInputExtended: ".jpg, .jpeg, .png, .gif",
    extension: /(\.jpg|\.jpeg|\.png|\.gif)$/i,
    type: /^(image)/i,
  },
  txt: {
    acceptedInput: ".txt",
    extension: /(\.txt)$/i,
    type: /^(text\/plain)$/,
  },
  rtf: {
    acceptedInput: ".rtf",
    extension: /(\.rtf)$/i,
    type: /^(text\/rtf)$/,
  },
  csv: {
    acceptedInput: ".csv",
    extension: /(\.csv)$/i,
    type: /^(text\/csv)$/,
  },
  json: {
    acceptedInput: ".json",
    extension: /(\.json)$/i,
    type: /^(application\/json)$/,
  },
  doc: {
    acceptedInput: ".doc",
    extension: /(\.doc)$/i,
    type: /^(application\/msword)$/,
  },
  docx: {
    acceptedInput: ".docx",
    extension: /(\.docx)$/i,
    type: /^(application\/vnd.openxmlformats-officedocument.wordprocessingml.document)$/,
  },
  ppt: {
    acceptedInput: ".ppt",
    extension: /(\.ppt)$/i,
    type: /^(application\/vnd.ms-powerpoint)$/,
  },
  pptx: {
    acceptedInput: ".pptx",
    extension: /(\.pptx)$/i,
    type: /^(application\/vnd.openxmlformats-officedocument.presentationml.presentation)$/,
  },
  // NOTE: disabling .xls extension type, as the file input reader (for chrome on mac) has a bug where MIME type isn't correctly set
  //       https://bugs.chromium.org/p/chromium/issues/detail?id=105382
  // xls: {
  //   acceptedInput: '.xls',
  //   extension: /(\.xls)$/i,
  //   type: /^(application\/vnd.ms-excel)$/,
  // },
  xlsx: {
    acceptedInput: ".xlsx",
    extension: /(\.xlsx)$/i,
    type: /^(application\/vnd.openxmlformats-officedocument.spreadsheetml.sheet)$/,
  },
  pdf: {
    acceptedInput: ".pdf",
    extension: /(\.pdf)$/i,
    type: /^(application\/pdf)$/,
  },
});

export default {
  getSupportedAttachments,
  isImage,
};
